<template>
  <div>
    <el-dialog
      title="Export"
      :visible.sync="shouldShow"
      @close="closeEvent"
      width="30%"
    >
      <eden-file-export
        :data="exportData"
        @exported="closeEvent"
        @cancelled="closeEvent"
      >
        <el-form label-position="top" :model="form">
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Select the data you'd like to export">
                <el-checkbox-group v-model="form.fields" :max="5">
                  <el-checkbox
                    v-for="(value, key, i) in fields"
                    :key="i"
                    :label="key"
                    :disabled="key === 'customer'"
                  >
                    {{ value }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Select data format">
                <el-radio-group v-model="form.format">
                  <el-radio
                    v-for="(key, value, i) in formats"
                    :key="i"
                    :label="value"
                  >
                    {{ key }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="is-flex justify-end">
          <el-button
            type="primary"
            :loading="exporting"
            @click="getExportData"
            :disabled="!form.format || !form.fields.length"
            >Export</el-button
          >
        </div>
      </eden-file-export>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ProvisionedOrdersExport",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    period: {
      type: String,
      default: "",
    },
    service: {
      type: String,
      default: "",
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    dataTime: {
      type: [Date, String],
      default: "",
    },
  },

  data() {
    return {
      fields: {
        order_id: "Order Id",
        order_type: "Order Type",
        customer: "Customer",
        gardener: "Gardener",
        sp: "Service Partner",
        status: "Status",
      },
      formats: {
        pdf: "PDF",
        csv: "CSV",
        xls: "Excel",
      },
      form: {
        fields: ["customer"],
        format: "",
      },
      exportData: {},
      exporting: false,
    };
  },

  computed: {
    shouldShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  watch: {
    show() {
      if (this.show) {
        switch (this.service) {
          case "beauty":
            this.fields["type"] = "Type";
            break;
          case "cleaning":
            this.fields["type"] = "Type";
            this.fields["rooms"] = "No. of Rooms";
            break;
          case "laundry":
            this.fields["type"] = "Type";
            this.fields["bags"] = "No. of Bags";
            break;
          case "meal":
            this.fields["meals"] = "Meals";
            break;
          default:
            break;
        }
      }
    },

    exporting() {
      if (!this.exporting) {
        this.closeEvent();
      }
    },
  },
  methods: {
    closeEvent() {
      this.form.fields = ["customer", "meals"];
      this.form.format = "";
      this.exporting = false;
      this.shouldShow = false;
    },

    getExportData() {
      this.exporting = true;
      this.formatExportData(this.data);
    },

    formatExportData(orders) {
      let title;
      if (this.period) {
        let period = this.formatPeriodDate(this.period, "do m, y");
        let updated = this.formatDateAndTime(this.dataTime, "do m, y");
        let date = this.formatDateAndTime(new Date(), "do m, y");
        title = `Orders - ${period}\nDownloaded at - ${updated}\nExported at - ${date}`;
      } else {
        const date = this.formatDate(this.$route.params.date, "ddd do, m y");
        title = `Orders - ${date}`;
      }

      let headers = {
        sn: "S/N",
      };
      let data = [];

      this.form.fields.forEach((key) => (headers[key] = this.fields[key]));

      data = orders.map((item, index) => {
        return {
          sn: index + 1,
          customer: this.formatName(item.customer),
          order_id: item.id,
          meals: item.meals
            ? item.meals.map((item) => {
                return `${this.formatMealName(item)}\n`;
              })
            : [],
          type: item.type ? this.unformatSlug(item.type) : "-",
          order_type: item.is_one_time_order ? "One-time" : "Subscription",
          rooms: item.rooms ? item.rooms : "-",
          bags: item.bags ? item.bags : "-",
          gardener: item.gardener,
          sp: item.sp,
          status: item.confirmed ? "Confirmed" : "Edited",
        };
      });
      this.exportData = {
        title,
        headers,
        data,
        fileName: "Orders",
        titleMargin: 44,
        format: this.form.format,
      };
      this.exporting = false;
    },
  },
};
</script>
<style lang="scss" scoped></style>
